import baseTheme from "@/themes/baseTheme";
import styled from "styled-components";

export const Tile = styled.div`
  height: 300px;
  width: 100%;
  border: 1px solid #ccc;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: all 0.3s linear;
  cursor: pointer;

  &:hover {
    border: 1px solid ${baseTheme.token.colorPrimary};
    color: ${baseTheme.token.colorPrimary};
  }
`;

export const TileTitle = styled.div`
  padding: 1rem 0;
  font-size: 2em;
  text-align: center;
`;
